import React, { Component } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import parseJwt from '../../../services/utils/parseJwt';

export default class DatadogUserTagger extends Component{
    render(){
        const { user } = this.props;
        console.log("   ~~~ DatadogUserTagger");
        console.log(user);
        const jwt = parseJwt(user.token);
        console.log(jwt)
        datadogRum.setUser({
            id: user.currentUserId,
            organization: jwt.profile.organization,
            role: user.role
        });
        return(<span></span>);
    }

}


// WEBPACK FOOTER //
// ./src/components/containers/datadog-user-tagger/datadog-user-tagger.js